import React, { Component } from 'react';
import { connect } from 'react-redux';
import './DetailsContractorsLienReleasesTable.css';
import SimpleTable from 'components/shared/table/SimpleTable';
import DocumentLink from 'components/shared/document/DocumentLink';
import Button from 'components/shared/button/Button';
import { deleteContractorLienReleaseRequest } from 'actions/admin/work-orders/details/details';
import { getContractorLienReleases } from 'selectors/admin/work-orders/details/details';

class DetailsContractorsLienReleasesTable extends Component {
  mapContractorLienReleases = (contractorLienReleases) => {
    return contractorLienReleases.map((contractorLienRelease) => {
      return [
        contractorLienRelease.contractor_name,
        <div className="file-viewer">
          <DocumentLink
            showIcon={false}
            showLink={true}
            url={contractorLienRelease.document.document.url}
          />
        </div>,
        <Button
          key={1}
          className="button-blue-grey delete"
          label="Delete"
          onClick={() => this.handleDelete(contractorLienRelease.id)}
        />,
      ];
    });
  };

  handleDelete = (contractorLienReleaseId) => {
    this.props.dispatch(
      deleteContractorLienReleaseRequest(contractorLienReleaseId)
    );
  };

  render() {
    const headers = ['CONTRACTOR', 'DOCUMENT'];

    return (
      <div className="details-contractor-lien-releases">
        <SimpleTable
          headers={headers}
          rows={this.mapContractorLienReleases(
            this.props.contractorLienReleases
          )}
          emptyMessage="No Final Unconditional Lien Releases"
        />
      </div>
    );
  }
}

export default connect((state) => {
  return {
    contractorLienReleases: getContractorLienReleases(state),
  };
})(DetailsContractorsLienReleasesTable);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/contractors-lien-releases/DetailsContractorsLienReleasesTable.js